/**
 * @generated SignedSource<<6c990cc9cae29be3049cd26987d95e7d>>
 * @relayHash f352cba41fdb7e45612ba8e8c63f4924
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 06b92e70fa740f611534cdf8a6c534986b8fd02bf146f9efe7aae5e4330ec5d3

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useContentStarUnstarMutation$variables = {
  contentId: string;
};
export type useContentStarUnstarMutation$data = {
  readonly unfavouritePage: {
    readonly content: {
      readonly id: string | null | undefined;
      readonly metadata: {
        readonly currentuser: {
          readonly favourited: {
            readonly isFavourite: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
      };
    };
  } | null | undefined;
};
export type useContentStarUnstarMutation = {
  response: useContentStarUnstarMutation$data;
  variables: useContentStarUnstarMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "contentId"
          }
        ],
        "kind": "ObjectValue",
        "name": "favouritePageInput"
      }
    ],
    "concreteType": "FavouritePagePayload",
    "kind": "LinkedField",
    "name": "unfavouritePage",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "ContentMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "FavouritedSummary",
                    "kind": "LinkedField",
                    "name": "favourited",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useContentStarUnstarMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContentStarUnstarMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f352cba41fdb7e45612ba8e8c63f4924",
    "id": "06b92e70fa740f611534cdf8a6c534986b8fd02bf146f9efe7aae5e4330ec5d3",
    "metadata": {},
    "name": "useContentStarUnstarMutation",
    "operationKind": "mutation",
    "text": "mutation useContentStarUnstarMutation($contentId:ID!){unfavouritePage(favouritePageInput:{pageId:$contentId}){content{id,metadata{currentuser{favourited{isFavourite}}}}}}"
  }
};
})();

(node as any).hash = "93f47afb6f09bd32bab5f61b3e99d199";

export default node;
